import { NavBar } from "../Navbar/NavBar";
import axios from "axios";
import { React, Fragment, useState, useEffect } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./retail.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Sidebar from "../Sidebar";

const GridSingleId = () => {
  const [orders, setOrders] = useState([]);
  const [grids, setGrids] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [open, setOpen] = useState(false);
  const [sourcers, setSourcers] = useState([]);
  const [totalCP, setTotalCP] = useState("");
  const [marginPercentage, setMarginPercentage] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [displayedTotalCP, setDisplayedTotalCP] = useState(null);
  const [displayedMargin, setDisplayedMargin] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState(null);
  const [supplierDetails, setSupplierDetails] = useState({});
  const [localMarginPercentage, setLocalMarginPercentage] = useState({});
  const [localTotalCP, setLocalTotalCP] = useState({});
  const [loading, setLoading] = useState(false);
  const [laborCharge, setLaborCharge] = useState("");
  const [submittedLaborCharges, setSubmittedLaborCharges] = useState({});

  const navigate = useNavigate();

  const { grid_id } = useParams();

  const totalPages = Math.ceil(totalOrders / 10);

  useEffect(() => {
    const fetchOrders = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `/workflow/api/retailers/grids/orders/${grid_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status) {
          setOrders(response.data.aggregated_orders);
        }
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      }
    };

    fetchOrders();
  }, [grid_id]);

  const calculateMarginPercentage = (totalSP, totalCP) => {
    const margin =
      totalSP && totalCP ? ((totalSP - totalCP) / totalSP) * 100 : 0;
    return parseFloat(margin.toFixed(2));
  };

  const calculateTotalCP = (totalSP, marginPercentage) => {
    const totalCP =
      totalSP && marginPercentage
        ? totalSP - (marginPercentage * totalSP) / 100
        : 0;
    return parseFloat(totalCP.toFixed(2));
  };

  const handleTotalCPChange = (totalSP, event) => {
    const newTotalCP = {
      ...localTotalCP,
      [selectedOrder.dist_user_id]: Number(event.target.value),
    };
    setLocalTotalCP(newTotalCP);
    const newMargin = {
      ...localMarginPercentage,
      [selectedOrder.dist_user_id]: calculateMarginPercentage(
        finalSP,
        newTotalCP[selectedOrder.dist_user_id]
      ),
    };
    setLocalMarginPercentage(newMargin);
  };

  const handleMarginPercentageChange = (totalSP, event) => {
    const newMargin = {
      ...localMarginPercentage,
      [selectedOrder.dist_user_id]: Number(event.target.value),
    };
    setLocalMarginPercentage(newMargin);
    const newTotalCP = {
      ...localTotalCP,
      [selectedOrder.dist_user_id]: calculateTotalCP(
        finalSP,
        newMargin[selectedOrder.dist_user_id]
      ),
    };
    setLocalTotalCP(newTotalCP);
  };

  useEffect(() => {
    const fetchSourcers = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get("/workflow/api/retailers/sourcers", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status) {
          setSourcers(response.data.sourcers);

          const mappedSupplierDetails = response.data.sourcers.reduce(
            (acc, sourcer) => {
              acc[sourcer.user_id] = sourcer.user_id || sourcer.mobile_number;
              return acc;
            },
            {}
          );
          setSupplierDetails(mappedSupplierDetails);
        }
      } catch (error) {
        console.error("Failed to fetch sourcers:", error);
      }
    };

    fetchSourcers();
  }, []);

  const sourcerOptions = sourcers.map((sourcer) => ({
    value: sourcer.user_id,
    label: sourcer.firm_name || "N/A",
  }));

  const formatDate = (dateString) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const nth = (d) => {
      if (d > 3 && d < 21) return "th";
      switch (d % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const date = new Date(dateString);

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return `${day}${nth(day)} ${monthNames[monthIndex]} ${year}`;
  };

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    const fetchGrids = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get("/workflow/api/retailers/grids", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.status) {
          setGrids(response.data.grids.rows);
        }
      } catch (error) {
        console.error("Failed to fetch grids:", error);
      }
    };

    fetchGrids();
  }, []);

  const handleModalOpen = (order) => {
    setSelectedOrder(order);
  };

  const handleModalClose = () => {
    setSelectedOrder(null);
  };

  const handleSubmit = () => {
    const selectedSupplierId = selectedOrder.dist_user_id;

    if (!selectedSupplier[selectedSupplierId]) {
      toast.error("Please select a supplier before submitting", {
        autoClose: 1000,
      });
      return;
    }

    const currentMarginPercentage = localMarginPercentage[selectedSupplierId];
    const currentTotalCP = localTotalCP[selectedSupplierId];

    if (!currentMarginPercentage) {
      toast.error("Please enter a margin percentage before submitting", {
        autoClose: 1000,
      });
      return;
    }

    if (!currentTotalCP) {
      toast.error("Please enter a total CP before submitting", {
        autoClose: 1000,
      });
      return;
    }

    const newMarginPercentage = parseFloat(currentMarginPercentage);
    const newTotalCP = parseFloat(currentTotalCP);

    setMarginPercentage({
      ...marginPercentage,
      [selectedSupplierId]: newMarginPercentage,
    });
    setTotalCP({
      ...totalCP,
      [selectedSupplierId]: newTotalCP,
    });

    toast.success("Supplier added successfully", { autoClose: 1000 });
    handleModalClose();
  };

  const placeOrder = async (constructedOrders) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        "/workflow/api/retailers/grids/place/order",
        { orders: constructedOrders },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        console.log("Order placed successfully:", response.data);
        toast.success("Order placed successfully", { autoClose: 1000 });

        setTimeout(() => {
          navigate("/distributors-lead-retail");
        }, 3000);
      } else {
        console.error("Failed to place order:", response.data);
        toast.error("Failed to place order", { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Failed to place order:", error);
      toast.error("Failed to place order", { autoClose: 1000 });
    }
  };

  const handlePlaceOrder = () => {
    setLoading(true);
    console.log(
      "Submitted labor charges before placing orders:",
      submittedLaborCharges
    );
    const constructedOrders = Object.keys(selectedSupplier).map(
      (distUserId) => {
        const gridId = grid_id;
        const buyerId = Number(distUserId);
        const supplierId = selectedSupplier[distUserId].value;
        const margin = marginPercentage[distUserId];
        const totalCp = totalCP[distUserId];
        const orderObj = orders.find(
          (order) => order.dist_user_id === distUserId
        );
        const totalSp = orderObj ? orderObj.total_sp_cal : 0;
        const labor_charge =
          submittedLaborCharges[distUserId] !== undefined
            ? submittedLaborCharges[distUserId]
            : 0;
        console.log(`Labor charge for order ${distUserId}:`, labor_charge);
        const finalSP = Number(totalSp) + Number(labor_charge);

        return {
          grid_id: gridId,
          buyer_id: buyerId,
          supplier_id: supplierDetails[supplierId],
          margin: margin,
          total_cp: totalCp,
          total_sp: finalSP,
          gst: selectedOrders?.gst || 0,
          labour_charge: labor_charge,
        };
      }
    );

    const isAllLaborChargesAdded = constructedOrders.every(
      (order) => order.labour_charge !== undefined
    );

    if (!isAllLaborChargesAdded) {
      toast.error("Please add labor charges for all orders before submitting");
      setLoading(false);
      return; // Don't proceed to place the order
    }

    const isValid = constructedOrders.every((order) => {
      return (
        order.grid_id !== undefined &&
        order.buyer_id !== undefined &&
        order.supplier_id !== undefined &&
        order.margin !== undefined &&
        order.total_cp !== undefined &&
        order.total_sp !== undefined &&
        order.gst !== undefined &&
        order.labour_charge !== undefined
      );
    });

    const isAllSuppliers = constructedOrders.length === orders.length;
    if (isValid && isAllSuppliers) {
      placeOrder(constructedOrders).then(() => {
        setLoading(false);
      });
    } else if (!isValid) {
      toast.error("Please complete all order details before submitting");
      setLoading(false);
    } else {
      toast.error("Please add details for all suppliers before submitting");
      setLoading(false);
    }
  };

  //----------------------------------------- Labour Charge Modal Start -------------------------------------//
  const handleAddLaborCharge = (order) => {
    setSelectedOrders(order);
    console.log("selectedOrders in handleAddLaborCharge:", selectedOrders);
    setLaborCharge("");
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setSelectedOrders(null);
  };
  const gstAmount = (laborCharge * (selectedOrders?.gst || 0)) / 100;
  const finalTotalSP =
    Number(laborCharge) + gstAmount + Number(selectedOrders?.total_sp_cal);

  const handleSubmitLabor = () => {
    console.log("selectedOrders in handleSubmitLabor:", selectedOrders);

    if (selectedOrders && selectedOrders.dist_user_id !== undefined) {
      setSubmittedLaborCharges((prevCharges) => {
        const updatedCharges = {
          ...prevCharges,
          [selectedOrders.dist_user_id]: laborCharge,
        };
        console.log("Submitted labor charges: ", updatedCharges);
        return updatedCharges;
      });
      toast.success("Labor charges added successfully", { autoClose: 1000 });
    } else {
      console.error("Error: selected order is not defined or has no id");

      toast.error("Error: selected order is not defined or has no id", {
        autoClose: 1000,
      });
    }
    setSelectedOrders(null);
  };
  const finalSP = Number(selectedOrder?.total_sp_cal) + Number(laborCharge);

  //----------------------------------------- Labour Charge Modal End -------------------------------------//

  return (
    <div className="flex">
      <div className="mt-3 ml-8 builk-main ">
        {loading ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <ClipLoader color="#4A1AC7" size={50} />
          </div>
        ) : null}
        {/*------------------------------------------- Tabs List Started --------------------------------------- */}
        <ToastContainer />

        {/*------------------------------------------- Tabs List Ended --------------------------------------- */}
        <div className="flex justify-end mt-20 gap-8">
          <nav
            className="flex text-gray-600 dark:text-gray-200 bg-gray-100 dark:bg-gray-900 w-full items-start p-2 space-y-4 rounded-md"
            aria-label="Breadcrumb"
          >
            <ol className="inline-flex items-center space-x-1 md:space-x-4 pt-3">
              <li className="inline-flex items-center">
                <Link
                  to="/bulkorder"
                  className="text-gray-600 dark:text-gray-200 inline-flex ml-1 md:ml-2 text-sm font-medium hover:underline"
                >
                  <svg
                    className="w-5 h-5 mr-2.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                  </svg>
                  Bulk Workflow
                </Link>
              </li>
              <li>
                <div className="flex items-center">
                  <span className="mx-2.5 text-gray-500 dark:text-gray-300">
                    /
                  </span>
                  <Link
                    to="/distributors-lead-retail"
                    className="text-gray-600 dark:text-gray-200 ml-1 md:ml-2 text-sm font-medium hover:underline"
                  >
                    Distributors Lead Retailer
                  </Link>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <span className="mx-2.5 text-gray-500 dark:text-gray-300">
                    /
                  </span>
                  <span className="text-gray-600 dark:text-gray-200 ml-1 md:ml-2 text-sm font-medium hover:underline">
                    Grid No.{grid_id}
                  </span>
                </div>
              </li>
            </ol>
          </nav>
          <button
            onClick={handlePlaceOrder}
            className="mr-2 rounded-md bg-green-600 px-5 py-1.5 text-base font-semibold leading-7 text-white hover:bg-green-500"
          >
            Submit
          </button>
        </div>

        {/*------------------------------------------- Grid Lists Starts--------------------------------------- */}

        <div className="text-gray-500 ">
          <section className="fluid w-full  px-2">
            <div className="flex items-center justify-between"></div>
            <div className="flex flex-col mt-2 ">
              <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                  <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <table className="min-w-full bg-cyan-500 shadow-lg shadow-cyan-500/50 ">
                      <thead className="bg-gray-50 dark:bg-gray-800 ">
                        <tr className="divide-x divide-gray-200">
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Buyer Name
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Total SP
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Total CP
                          </th>

                          {/* <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Labour Charge
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Final SP <br /> (Including Labor Charge)
                          </th> */}
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Margin(%)
                          </th>
                          <th
                            scope="col"
                            className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-gray-800"
                          >
                            Select Supplier
                          </th>
                        </tr>
                      </thead>

                      <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                        {orders.map((order) => (
                          <tr
                            key={order.dist_user_id}
                            className="divide-x divide-gray-200"
                          >
                            <td className="py-4 px-4 whitespace-nowrap text-center">
                              <div className="flex items-center justify-center">
                                <div>
                                  <div className="text-sm text-gray-500 dark:text-gray-300">
                                    {order.buyer_name}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="px-12 py-4 whitespace-nowrap text-center">
                              <div className="text-sm text-gray-900 dark:text-white">
                                {` ₹ ${formatNumberWithCommas(
                                  order.total_sp_cal
                                )}`}
                              </div>
                            </td>
                            <td className="px-4 py-4 whitespace-nowrap text-center">
                              {totalCP[order.dist_user_id]
                                ? totalCP[order.dist_user_id]
                                : ""}
                            </td>

                            {/* <td className="px-4 py-4 whitespace-nowrap text-center">
                              <button
                                className={`rounded-md px-3.5 py-1.5 text-base font-semibold leading-7 ${
                                  submittedLaborCharges[order.dist_user_id]
                                    ? "bg-green-600 hover:bg-green-500 text-white"
                                    : "bg-indigo-600 hover:bg-indigo-500 text-white"
                                }`}
                                key={order.dist_user_id}
                                onClick={() => handleAddLaborCharge(order)}
                              >
                                {submittedLaborCharges[order.dist_user_id]
                                  ? `₹${
                                      submittedLaborCharges[order.dist_user_id]
                                    }`
                                  : "Add Labor Charges"}
                              </button>
                            </td> */}
                            {/* <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-dark text-sm">
                                ₹{" "}
                                {formatNumberWithCommas(
                                  isNaN(
                                    Number(order.total_sp_cal) +
                                      Number(
                                        submittedLaborCharges[
                                          order.dist_user_id
                                        ]
                                      )
                                  )
                                    ? 0
                                    : Number(order.total_sp_cal) +
                                        Number(
                                          submittedLaborCharges[
                                            order.dist_user_id
                                          ]
                                        )
                                )}
                              </span>
                            </td> */}

                            <td className="px-4 py-4 whitespace-nowrap text-center">
                              {marginPercentage[order.dist_user_id]
                                ? marginPercentage[order.dist_user_id]
                                : ""}
                            </td>

                            <td className="px-4 py-4 whitespace-nowrap text-center">
                              <button
                                className={`rounded-md px-3.5 py-1.5 text-base font-semibold leading-7 ${
                                  selectedSupplier[order.dist_user_id]
                                    ? "bg-green-600 hover:bg-green-500 text-white"
                                    : "bg-indigo-600 hover:bg-indigo-500 text-white"
                                }`}
                                key={order.dist_user_id}
                                onClick={() => handleModalOpen(order)}
                              >
                                {selectedSupplier[order.dist_user_id]
                                  ? selectedSupplier[order.dist_user_id].label
                                  : "Select Supplier"}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {selectedOrder && (
                      <Modal
                        open={selectedOrder !== null}
                        onClose={handleModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            borderRadius: 5,
                            boxShadow: 24,
                            p: 4,
                          }}
                        >
                          <div className="grid w-full max-w-sm items-center gap-1.5  text-lg font-normal  ">
                            Select Supplier
                            <h6 id="modal-modal-title" className="pt-2">
                              <Select
                                placeholder="Select Supplier"
                                options={sourcerOptions}
                                onChange={(option) =>
                                  setSelectedSupplier({
                                    ...selectedSupplier,
                                    [selectedOrder.dist_user_id]: option,
                                  })
                                }
                                value={
                                  selectedSupplier[selectedOrder.dist_user_id]
                                }
                              />
                            </h6>
                          </div>
                          <div class="grid w-full max-w-sm items-center gap-1.5 mt-4">
                            <label
                              class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                              for="email"
                            >
                              Total SP
                            </label>
                            <input
                              class="flex h-10 w-full rounded-md border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                              type="number" onWheel={(e) => e.target.blur()}
                              placeholder="Total SP"
                              value={
                                Number(selectedOrder.total_sp_cal) +
                                Number(laborCharge)
                              }
                              disabled
                            />
                          </div>
                          <div class="grid w-full max-w-sm items-center gap-1.5 mt-4">
                            <label
                              class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                              for="email"
                            >
                              Margin(%)
                            </label>
                            <input
                              class="flex h-10 w-full rounded-md border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                              type="number" onWheel={(e) => e.target.blur()}
                              placeholder="Margin"
                              value={
                                localMarginPercentage[
                                  selectedOrder.dist_user_id
                                ] ||
                                marginPercentage[selectedOrder.dist_user_id] ||
                                ""
                              }
                              onChange={(event) =>
                                handleMarginPercentageChange(
                                  selectedOrder.total_sp_cal,
                                  event
                                )
                              }
                            />
                          </div>
                          <div class="grid w-full max-w-sm items-center gap-1.5 mt-4">
                            <label
                              class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                              for="email"
                            >
                              Total CP
                            </label>
                            <input
                              class="flex h-10 w-full rounded-md border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                              type="number" onWheel={(e) => e.target.blur()}
                              placeholder="Total CP"
                              value={
                                localTotalCP[selectedOrder.dist_user_id] ||
                                totalCP[selectedOrder.dist_user_id] ||
                                ""
                              }
                              onChange={(event) =>
                                handleTotalCPChange(
                                  selectedOrder.total_sp_cal,
                                  event
                                )
                              }
                            />
                          </div>
                          <div class="grid w-full max-w-sm items-center gap-1.5 mt-4">
                            <button
                              className="rounded-md bg-indigo-600 px-3.5 py-1.5 text-base font-semibold leading-7 text-white hover:bg-indigo-500"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </Box>
                      </Modal>
                    )}

                    {selectedOrders && (
                      <Modal
                        open={selectedOrders !== null}
                        onClose={handleCloseModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        {/* Modal content */}
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            borderRadius: 5,
                            boxShadow: 24,
                            p: 4,
                          }}
                        >
                          <div className="grid w-full max-w-sm items-center gap-1.5 text-lg font-normal">
                            Add Labor Charges
                            <div id="modal-modal-description" className="pt-2">
                              <div>
                                {/* GST input */}
                                <div className="mt-4">
                                  <label
                                    className="text-sm font-medium"
                                    htmlFor="gst"
                                  >
                                    GST (%)
                                  </label>
                                  <input
                                    className="w-full h-10 rounded-md border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1"
                                    type="number" onWheel={(e) => e.target.blur()}
                                    id="gst"
                                    placeholder="Enter GST"
                                    value={selectedOrders?.gst || 0}
                                    disabled
                                  />
                                </div>

                                {/* Labor charge input */}
                                <div className="mt-4">
                                  <label
                                    className="text-sm font-medium"
                                    htmlFor="labor-charge"
                                  >
                                    Labor Charge
                                  </label>
                                  <input
                                    className="w-full h-10 rounded-md border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1"
                                    type="number" onWheel={(e) => e.target.blur()}
                                    id="labor-charge"
                                    placeholder="Enter Labor Charge"
                                    value={laborCharge}
                                    onChange={(e) => {
                                      setLaborCharge(e.target.value);
                                      console.log(
                                        "Input value: ",
                                        e.target.value
                                      );
                                    }}
                                  />
                                </div>

                                {/* Total SP input */}
                                <div className="mt-4">
                                  <label
                                    className="text-sm font-medium"
                                    htmlFor="total-sp"
                                  >
                                    Total SP
                                  </label>
                                  <input
                                    className="w-full h-10 rounded-md border border-gray-300 bg-transparent py-2 px-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1"
                                    type="number" onWheel={(e) => e.target.blur()}
                                    id="total-sp"
                                    placeholder="Enter Total SP"
                                    value={finalTotalSP}
                                    disabled
                                  />
                                </div>

                                {/* Submit button */}
                                <div className="mt-4">
                                  <button
                                    className="rounded-md bg-indigo-600 px-3.5 py-1.5 text-base font-semibold leading-7 text-white hover:bg-indigo-500"
                                    onClick={handleSubmitLabor}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Box>
                      </Modal>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/*------------------------------------------- Grid List Ends --------------------------------------- */}
      </div>
    </div>
  );
};

export default GridSingleId;
